import { Route, Routes } from 'react-router-dom';
import { MeetingShow } from '../meetings/Show';
import { MeetingProtocolEdit } from '../meetings/components/ProtocolEdit';
import { MeetingParticipantsShow } from '../meetings/components/ParticipantsShow';
import { MeetingConcernsShow } from '../meetings/components/MeetingConcernsShow';
import { MeetingTodoShow } from '../meetings/components/TodoShow';
import { useBoardMeetingSuspenseQuery } from './BoardMeeting.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';

export const BoardMeetingShowWithRoutes = ({ meetingId }: { meetingId: string }) => {
  const companyId = useCompanyId();
  const {
    data: { meeting, meetingConcerns, agendaItems, meetingErrors },
  } = useBoardMeetingSuspenseQuery({ variables: { companyId, meetingId }, fetchPolicy: 'cache-and-network' });

  return (
    <Routes>
      <Route path="*" element={<MeetingShow meetingId={meetingId} />}>
        <Route
          index
          path="protocol"
          element={
            <MeetingProtocolEdit
              meeting={meeting}
              meetingConcerns={meetingConcerns}
              agendaItems={agendaItems}
              movableRange={[]}
            />
          }
        />
        <Route
          path="participants"
          element={<MeetingParticipantsShow meeting={meeting} meetingErrors={meetingErrors} />}
        />
        <Route path="concerns" element={<MeetingConcernsShow meetingId={meetingId} />} />
        <Route path="todos" element={<MeetingTodoShow meetingId={meetingId} />} />
      </Route>
    </Routes>
  );
};
